import { render, staticRenderFns } from "./BaseCard.vue?vue&type=template&id=549719be&scoped=true"
import script from "./BaseCard.vue?vue&type=script&lang=ts"
export * from "./BaseCard.vue?vue&type=script&lang=ts"
import style0 from "./BaseCard.vue?vue&type=style&index=0&id=549719be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549719be",
  null
  
)

export default component.exports